import Crud from './crud'
var crud = new Crud('declaration', 'khai báo hải quan');
import { sendSuccessNotice, sendErrorNotice, refreshResource } from '@/commons/utils';
import { request_list, update_detail, create_detail, remove_detail, export_list } from '@/commons/hpod';
import Vue from 'vue';
var FileSaver = require('file-saver');

const state = {
    ...crud.state,
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions,
    exportDeclaration({ commit }, param) {
        return new Promise((resolve) => {
            commit("setLoading", { loading: true });
            export_list(crud.endpoint, res => {
                commit("setLoading", { loading: false });
                const disposition = (res.headers && (res.headers['content-disposition'] || res.headers['Content-Disposition'])) || '';
                const matched = disposition.match(/filename="?([^"]+)"?/i);
                let fileName = matched && matched[1] ? matched[1] : `KhaiBao_${param.order_id || 'all'}.xlsx`;
                if (param.vehicle_code) {
                    fileName = `KhaiBao_${param.vehicle_code}.xlsx`;
                }
                var blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,"});
                FileSaver.saveAs(blob, fileName);
                sendSuccessNotice('Xuất file excel thành công.');
                resolve(res);
            }, Vue.http, param, this.state.authentication.token, 'export_excel');
        });
    },
};
const mutations = {
    ...crud.mutations,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
